import React from 'react';
import { FaExclamationCircle } from 'react-icons/fa';
import styled, { css, keyframes } from 'styled-components';

import {
  curtainWipeIn,
  curtainWipeInAfter,
  curtainWipeInAfterVertical
} from './keyframes';
import { slideInTime } from './section';

const wipeInTime = 0.7;
const wipeInDelay = -0.4;

export const HeadingContainer = styled.header`
  position: relative;
  margin-left: 30%;
  margin-right: auto;
  width:40%;

  ${props =>
      props.image &&
      css`
        background-repeat:no-repeat;
        background-size:cover;
        background-position: center center;
        background-image: url(${props.image});
        `
  }
`;

const headingWipeIn = keyframes`
  0% {
    opacity: 0;
    transform: translate(-15%, 0);
  }
  100% {
    opacity: 1;
    transform: translate(0, 0);
  }
`;

const headingWipeInVertical = keyframes`
  0% {
    opacity: 0;
    transform: translate(0, -15%);
  }
  100% {
    opacity: 1;
    transform: translate(0, 0);
  }
`;
const Heading = styled.h4`
  font-family: DINCondensed-Regular;
  font-size: 2em;
  font-weight: bold;
  letter-spacing: 0.5rem;
  margin: 0;
  text-align: center;
  white-space: nowrap;
`;
//color: transparent;
//  overflow: hidden;

const Heading2 = styled.h2`
  font-family: DINCondensed-Regular;
  font-size: 5em;
  font-weight: bold;
  letter-spacing: 0.2rem;
  margin: 0;
//  overflow: hidden;
  text-align: center;
  white-space: nowrap;
  background: none;
  //color: transparent;

  opacity: 0;
//  transform: translate(-15%, 0);
/*
  ${props =>
    props.invert
      ? css`
          color: rgba(17, 17, 17, 0.1);
        `
      : css`
          color: rgba(255, 255, 255, 0.2);
        `}


  ${props =>
    props.inView &&
    css`
      animation: ${headingWipeIn} ${wipeInTime}s
        cubic-bezier(0.02, 0.88, 0.58, 1) ${slideInTime + wipeInDelay + 0.4}s
        both;
    `}
*/
/*
  &::before {
    content: '';
    margin-left: -100%;
  }

  &::after {
    content: '';
    margin-right: -100%;
  }
*/
/*
  ${props =>
    props.vertical &&
    css`
      @media (min-width: 768px) {
        font-size: 7em;
        transform: translate(0, -15%);

        ${props =>
          props.inView &&
          css`
            animation-name: ${headingWipeInVertical};
          `}
      }
    `}
*/
`;
export default Heading;

export const SubHeading = styled.p`
  text-align: center;
  position: static;
  font-family: DINCondensed-Regular;
  margin: 0;
  font-size: 14px;
  font-weight: bold;
  padding-bottom: 4em;
  white-space: nowrap;
  background: none;
//  color: transparent;
`;

const StyledInformationHeading = styled.h2`
  display: flex;
  font-size: 1em;
  font-weight: normal;
  margin: 0;

  > *:first-child {
    align-items: center;
    background: #ffffff;
    color: #111111;
    display: inline-flex;
    margin: 0 auto;
    padding: 0.6em 1.2em;

    > *:first-child {
      color: ${props => props.theme.primary};
      margin-right: 0.4em;
    }
  }
`;

export const InformationHeading = ({ children, ...props }) => (
  <StyledInformationHeading {...props}>
    <span>
      <FaExclamationCircle size="1.2em" />
      {children}
    </span>
  </StyledInformationHeading>
);
